class FeelingwearSearch extends HTMLElement {
  // The Feelingwear embed renders either its floating button or, for first-time
  // visitors, an intro bubble whose inner area opens the widget (its "X" dismisses it).
  static #triggerSelector = '.fw-open-chat-button, .fw-open-chat-first-time-area > div';
  static #waitTimeout = 3000;

  constructor() {
    super();
    this.addEventListener('click', this.#onClick.bind(this));
  }

  async #onClick(event) {
    const link = event.target.closest('a');
    if (!link) return;
    event.preventDefault();

    const widgetTrigger = await this.#waitForWidget();
    if (widgetTrigger) {
      widgetTrigger.click();
      return;
    }

    window.location.href = link.href;
  }

  #findTrigger() {
    return document.querySelector(FeelingwearSearch.#triggerSelector);
  }

  #waitForWidget() {
    const existing = this.#findTrigger();
    if (existing) return Promise.resolve(existing);

    return new Promise((resolve) => {
      const observer = new MutationObserver(() => {
        const found = this.#findTrigger();
        if (!found) return;
        observer.disconnect();
        clearTimeout(timer);
        resolve(found);
      });
      const timer = setTimeout(() => {
        observer.disconnect();
        resolve(null);
      }, FeelingwearSearch.#waitTimeout);
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
}

customElements.define('feelingwear-search', FeelingwearSearch);
